import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class AppFooter {
  readonly currentYear = new Date().getFullYear();

  readonly rocketProducts = [
    { titleKey: 'footer.PRODUCT_REDFIN', descriptionKey: 'footer.PRODUCT_REDFIN_DESC', url: 'https://www.redfin.com/' },
    { titleKey: 'footer.PRODUCT_ROCKET_MORTGAGE', descriptionKey: 'footer.PRODUCT_ROCKET_MORTGAGE_DESC', url: 'https://rocket.com/mortgage/' },
    { titleKey: 'footer.PRODUCT_ROCKET_MONEY', descriptionKey: 'footer.PRODUCT_ROCKET_MONEY_DESC', url: 'https://www.rocketmoney.com/' },
    { titleKey: 'footer.PRODUCT_ROCKET_CARD', descriptionKey: 'footer.PRODUCT_ROCKET_CARD_DESC', url: 'https://www.rocketcard.com/' },
    { titleKey: 'footer.PRODUCT_ROCKET_LOANS', descriptionKey: 'footer.PRODUCT_ROCKET_LOANS_DESC', url: 'https://www.rocketloans.com/' },
    { titleKey: 'footer.PRODUCT_ROCKET_PRO', descriptionKey: 'footer.PRODUCT_ROCKET_PRO_DESC', url: 'https://www.rocketpro.com/' },
    { titleKey: 'footer.PRODUCT_ROCKET_CLOSE', descriptionKey: 'footer.PRODUCT_ROCKET_CLOSE_DESC', url: 'https://www.rocketclose.com/' },
  ];

  readonly rocketCloseLinks = [
    { textKey: 'footer.BUY_OR_SELL', url: 'https://www.rocketclose.com/home-buyers-sellers/about-title-insurance' },
    { textKey: 'footer.BROKERS', url: 'https://www.rocketclose.com/broker-title-escrow' },
    { textKey: 'footer.PARTNERS', url: 'https://www.rocketclose.com/partners' },
    { textKey: 'footer.FUNDING', url: 'https://www.rocketclose.com/funding' },
    { textKey: 'footer.CLEAR_SIGN', url: 'https://www.rocketclose.com/applications-and-services/clear-sign' },
    { textKey: 'footer.CAREERS', url: 'https://www.myrocketcareer.com/' },
  ];

  readonly legalLinks = [
    { textKey: 'footer.PRIVACY_POLICY', url: 'https://www.rocketclose.com/privacy-policy' },
    { textKey: 'footer.TERMS_OF_USE', url: 'https://www.rocketclose.com/terms-of-use' },
    { textKey: 'footer.DISCLOSURES', url: 'https://www.rocketclose.com/disclosures-licenses' },
    { textKey: 'footer.DO_NOT_SELL', url: 'https://info.rocketclose.com/state-privacy/' },
  ];

  readonly supportLinks = [
    { textKey: 'footer.CONTACT_US', url: 'https://www.rocketclose.com/contact' },
    { textKey: 'footer.LOGIN', url: 'https://www.rocketclose.com/login' },
    { textKey: 'footer.PARTNER_REGISTRATION', url: 'https://portal.rocketclose.com/Register' },
  ];

  readonly socialLinks = [
    { name: 'Facebook', icon: 'assets/icons/facebook-default.svg', url: 'https://www.facebook.com/RocketClose' },
    { name: 'Instagram', icon: 'assets/icons/instagram-default.svg', url: 'https://www.instagram.com/rocketclose/' },
    { name: 'LinkedIn', icon: 'assets/icons/linkedin-default.svg', url: 'https://www.linkedin.com/company/rocketclose' },
  ];
}
